import qs from "qs";

/** Query params sent to the HTTP transport — excludes language (already in base URL). */
export function prepareQueryParams(params: Record<string, unknown> = {}): Record<string, unknown> {
  const out: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;
    if (Array.isArray(value) && value.length === 0) continue;
    out[key] = value;
  }

  return out;
}

export function serializeQueryParams(params: Record<string, unknown>): string {
  return qs.stringify(prepareQueryParams(params), {
    arrayFormat: "repeat",
    skipNulls: true,
    encode: true,
  });
}

/** Serialized query string for ky `searchParams` (repeat array format). */
export function toSearchParams(params: Record<string, unknown> = {}): string | undefined {
  const query = serializeQueryParams(params);
  return query || undefined;
}
